module.exports = __webpack_public_path__ + "static/6-a2947acc3435582f0b11eb09443bf951.png";